import { txt } from "../../../services/translation"

export default function YouTube({section}){

    if( !section.youtube ) return <>{txt('unavailableContent')}</>

    return <iframe 
        title={section.title}
        width="100%" 
        height="99%" 
        src={section.youtube.source}
        frameBorder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowFullScreen={true}
    >
        {txt('unavailableContent')}
    </iframe>


}